// extracted by mini-css-extract-plugin
module.exports = {"EditorialImagesColumns":"styles_EditorialImagesColumns__ZwG91","imageContainer":"styles_imageContainer__UZnip","small":"styles_small__GXDBQ","large":"styles_large__zDHYe"};